import Component from './Desktop'

export default Component
